import { IonItem, IonLabel } from "@ionic/react";
import { Link } from "react-router-dom";
import styles from "./SubjectListItem.module.scss";

export const SubjectListItem = ({
  subject,
  fromSearch = false,
  fromBookmarks = false,
}) => {
  const pathname = `/subject/${subject.label.replace(/[^\w\s]/gi, '')
      .replace(/\s+/g, '')
      .toLowerCase()}`
  return (
  <Link
    to={{
      pathname,
      state: { subject, fromSearch, fromBookmarks },
    }}
  >
    <IonItem detail={true} lines="full" className={styles.categoryItem}>
      <img src={subject.image} alt="cover" className={styles.categoryImage} />

      <IonLabel className={styles.categoryDetails}>
        <h2>{subject.label}</h2>
        <p>{subject.courseCode}</p>
      </IonLabel>
    </IonItem>
  </Link>
);
}